import React, { useEffect } from 'react';
import { useState, useMemo } from 'react';
import { Form, Button, Spinner, Col, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion } from "react-bootstrap";
import { FaAngleDoubleDown } from 'react-icons/fa';
import { ProductStockVW} from '../Redux/MapAction';
import LoadingSpinner from '../../modules/Billing/Components/LoadingSpinner';
import DownloadDropdown from "../../modules/master/PrintDwopdown/ExcelDawnload";


const ProductStockSummaryReport = () => {

    const dispatch = useDispatch();
        const { register, setValue } = useForm();
        const [isAccordionOpen, setIsAccordionOpen] = useState(false);
        const handleAccordionToggle = () => {
            setIsAccordionOpen(!isAccordionOpen);
        };
    
        
        const currentDate = new Date();
       
        const fullDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-${currentDate.getDate().toString().padStart(2, "0")}`;
    
    
        const [startDate, setStartDate] = useState(fullDate);
       
    
        const [selectedZoneId, setSelectedZoneId] = useState(1);
        const [selectedDivisionId, setSelectedDivisionId] = useState(0);
        const [selectedAreaId, setSelectedAreaId] = useState(0);
        const [selectedTerritoryId, setSelectedTerritoryId] = useState(0);
    
        const handleChangeStartDate = ({ currentTarget: input }) => {
            setStartDate(input.value);
        };
    
    
        const handleSummeryReport = async () => {
            dispatch(
                ProductStockVW(
                startDate, 
                //toDate,
                selectedZoneId,
                selectedDivisionId,
                selectedAreaId,
                selectedTerritoryId,
                )
            )
    
        }
    
        
    
        useEffect(() => {
            initialData();
        }, [dispatch])
    
        const initialData = async () => {
            await dispatch(
                ProductStockVW(
                    startDate, 
                    //toDate,
                    selectedZoneId,
                    selectedDivisionId,
                    selectedAreaId,
                    selectedTerritoryId,
                )
            )
           
    
        }
        // const productStockDataViews = useSelector(state => state?.mapData?.productStockDataView?.productStockReports);
    
        // const nsmList = useSelector(state => state?.mapData?.productStockDataView?.nsmList);
        // const dsmList = useSelector(state => state?.mapData?.productStockDataView?.dsmList);
        // const asmList = useSelector(state => state?.mapData?.productStockDataView?.rmList);
        // const tsmList = useSelector(state => state?.mapData?.productStockDataView?.tsmList);

        const productStockDataViews = useSelector(
        state => state?.mapData?.productStockDataView?.productStockReports || []
        );

        const nsmList = useSelector(
        state => state?.mapData?.productStockDataView?.nsmList || []
        );

        const dsmList = useSelector(
        state => state?.mapData?.productStockDataView?.dsmList || []
        );

        const asmList = useSelector(
        state => state?.mapData?.productStockDataView?.rmList || []
        );

        const tsmList = useSelector(
        state => state?.mapData?.productStockDataView?.tsmList || []
        );
    
    
        const productStockDataViewIsLoading = useSelector(state => state?.mapData?.productStockDataViewIsLoading);
        const monthNames = [
            "January", "February", "March", "April", "May", "June", "July",
            "August", "September", "October", "November", "December"
        ];
        const monthNumber = productStockDataViews && productStockDataViews.length > 0 ? productStockDataViews[0]?.month : null;
       
        const [filters, setFilters] = useState({
            zone: '',
            division: '',
            region: '',
            territory: '',
            disPoint: ''
        });
    
        const [filteredData, setFilteredData] = useState([]);
        
    
    
        const handleFilterChange = (e) => {
            // alert(e.target.name)
        const { name, value } = e.target;        
        setFilters((prev) => ({ ...prev, [name]: value }));
        };
    
    
        const getUnique = (arr, key) => {
        if (!Array.isArray(arr)) return [];
    
        const values = arr.map(item => {
            const val = item[key];
            if (typeof val === 'string') return val.trim();
            return val;
        }).filter(val => val !== null && val !== undefined && val !== '');
    
        return [...new Set(values)];
        };
    
        
        const divisionOptions = getUnique(productStockDataViews, 'divisionName');
        const regionOptions = getUnique(productStockDataViews, 'regionName');
        const territoryOptions = getUnique(productStockDataViews, 'territoryName');
        const disPointOptions = getUnique(productStockDataViews, 'disPointName');
    
    
       
        useEffect(() => {
        // Make sure productStockDataViews is an array before filtering
        if (!Array.isArray(productStockDataViews)) {
            setFilteredData([]); // fallback to empty array
            return;
        }
    
        // Start with full dataset
        let data = [...productStockDataViews];
        
    
        // Apply filters one by one
        if (filters.zone) {
            data = data.filter(x => x.zoneId === filters.zone);
        }
    
        if (filters.division) {
            data = data.filter(x => x.divisionName === filters.division);
        }
    
        if (filters.region) {
            data = data.filter(x => x.regionName === filters.region);
        }
    
        if (filters.territory) {
            data = data.filter(x => x.territoryName === filters.territory);
        }
    
        if (filters.disPoint) {
            data = data.filter(x => x.disPointName === filters.disPoint);
        }
    
        // Set filtered result
        setFilteredData(data);
    }, [filters, productStockDataViews]);
    
    
     const reportTypes = [
      { zoneId: 1, label: "North Funtastic" },
      { zoneId: 2, label: "South Funtastic" },
      { zoneId: 7, label: "National Bakeman's" },
      { zoneId: 8, label: "National Confectionery" },
    ];
    
    // Handle zone checkbox toggle
    const handleZoneFilter = (zoneId) => {
      setSelectedZoneId(prev => prev === zoneId ? 1 : zoneId); // toggle
    
      handleSummeryReport();
      //setSelectedZoneId
    };  


    const getBgColorByField = (field) => {
    switch (field) {
        case "zone": return "#ffc000";      // light blue
        case "division": return "#8db5e3";  // light peach
        case "region": return "#ffc000";    // light green
        case "territory": return "#dedac5"; // light yellow
        case "dispoint": return "#c7daf2"; // light yellow
        default: return "";
    }
    };



    const getSummarizedData = (data) => {
  const summary = {};

  data.forEach((item) => {
    const key = `${item.zoneId}|${item.divisionId}|${item.regionId}|${item.territoryId}|${item.disPointId}`;

    if (!summary[key]) {
      summary[key] = {
        // IDs
        zoneId: item.zoneId,
        divisionId: item.divisionId,
        regionId: item.regionId,
        territoryId: item.territoryId,
        disPointId: item.disPointId,

        // Names
        zoneName: item.zoneName,
        divisionName: item.divisionName,
        regionName: item.regionName,
        territoryName: item.territoryName,
        disPointName: item.disPointName,

        // Values to summarize
        productOpeningPrice: 0,
        productLiftingPrice: 0,
        productIMSPrice: 0,
        productClosingPrice: 0,
        productDMGPrice: 0,
        productNetPrice: 0,
      };
    }

    summary[key].productOpeningPrice += item.productOpeningPrice || 0;
    summary[key].productLiftingPrice += item.productLiftingPrice || 0;
    summary[key].productIMSPrice += item.productIMSPrice || 0;
    summary[key].productClosingPrice += item.productClosingPrice || 0;
    summary[key].productDMGPrice += item.productDMGPrice || 0;
    summary[key].productNetPrice += item.productNetPrice || 0;
  });

  return Object.values(summary);
};
    
const summarizedData = getSummarizedData(filteredData);


const summarizedDataWithEmployees = useMemo(() => {
  if (!Array.isArray(summarizedData) || summarizedData.length === 0) return [];

  return summarizedData.map((item) => {
    const nsm = Array.isArray(nsmList) ? nsmList.find(n => n.zoneId === item.zoneId) : null;
    const dsm = Array.isArray(dsmList) ? dsmList.find(d => d.divisionID === item.divisionID) : null;
    const asm = Array.isArray(asmList) ? asmList.find(a => a.areaId === item.regionId) : null;
    const tsm = Array.isArray(tsmList) ? tsmList.find(t => t.territoryId === item.territoryId) : null;

    return {
      ...item,
      nsmName: nsm?.empName || '',
      dsmName: dsm?.empName || '',
      asmName: asm?.empName || '',
      tsmName: tsm?.empName || '',
    };
  });
}, [summarizedData, nsmList, dsmList, asmList, tsmList]);






    return (
        <div className='container ims-division-wise-report'>



            <div className=' container-fluid top_card3-map rounded mb-5'>
                <Accordion activeKey={isAccordionOpen ? "1" : "0"}>

                    <Accordion.Toggle as={Button} variant="link" eventKey="1" className="arrayButton" onClick={handleAccordionToggle}>
                        <div>
                            <div className="dailysales text-center dailysalesmargin dailysalesfont row  ">
                                <span className="sales-title-map" style={{ width: '400px', margin: 'auto' }} >Product Stock Summary
                                    <div>
                                        <FaAngleDoubleDown className="float-right toparrow blink-text dropdownArrow" />
                                        <span className="clickHere float-right">
                                            {isAccordionOpen ? "Click to Close" : "Click to Expand"}
                                        </span>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1" onEnter={() => setIsAccordionOpen(true)} onExit={() => setIsAccordionOpen(false)}>
                        <div>
                            <div className="row d-flex justify-content-center bg-blue ">
                                <div className="col-md-1.5 d-flex py-2 align-items-center justify-content-md-start justify-content-center">

                                    <Form.Group as={Col} controlId="formGridState">
                                        <label className="form-label">From Date</label>
                                        <Form.Control
                                        type="date"
                                        placeholder="Enter Deadweight"
                                        name="fromDate"
                                        value={startDate}
                                        className="form-control cusheight form-control"
                                        onChange={handleChangeStartDate}
                                        />
                                    </Form.Group>
                                    <div className="col-md-1.5 d-flex justify-content-center mt-5 ml-5">
                                   
                                        {startDate !== null ? (
                                            <button className="btn btn-primary btn-sm " onClick={() => handleSummeryReport()}>Filter</button>
                                            ) : null}
                                            
                                    </div> 
                                </div>
                            </div>                    

                        </div>

                    </Accordion.Collapse>
                </Accordion>



            </div>

            <div className=' container-fluid top_card3-map rounded mb-5'>                             
                <div className="col-md-12 d-flex py-2 align-items-center justify-content-md-start justify-content-center tsm-row-checkboxes">
                    {/* {reportTypes.map((type) => (
                    <div className="form-check " key={type.zoneId}>
                        <input
                        type="checkbox"
                        className="form-check-input"
                        value={type.zoneId}
                        checked={selectedZoneId === type.zoneId}
                        onChange={() => handleZoneFilter(type.zoneId)}
                        />
                        <label className="form-check-label">
                        {type.label}
                        </label>
                    </div>
                    ))} */}

                    {reportTypes.map((type) => (
                        <div className="form-check" key={type.zoneId}>
                            <input
                            type="checkbox"
                            className="form-check-input"
                            name="zone"
                            value={type.label}
                            checked={selectedZoneId === type.zoneId}
                            onChange={() => handleZoneFilter(type.zoneId)}
                            // onChange={handleFilterChange}
                            />
                            <label className="form-check-label">
                            {type.label}
                            </label>
                        </div>
                        ))}


                </div>

                {/* <div className="col-md-1.5 d-flex py-2 align-items-center justify-content-md-start justify-content-center">
                   
                    <div className="col">
                        <select className="form-select" name="division" value={filters.division} onChange={handleFilterChange}>
                        <option value="">All Divisions</option>
                        {divisionOptions.map((div, i) => <option key={i} value={div}>{div}</option>)}
                        </select>
                    </div>
                    <div className="col">
                        <select className="form-select" name="region" value={filters.region} onChange={handleFilterChange}>
                        <option value="">All Regions</option>
                        {regionOptions.map((reg, i) => <option key={i} value={reg}>{reg}</option>)}
                        </select>
                    </div>
                    <div className="col">
                        <select className="form-select" name="territory" value={filters.territory} onChange={handleFilterChange}>
                        <option value="">All Territories</option>
                        {territoryOptions.map((ter, i) => <option key={i} value={ter}>{ter}</option>)}
                        </select>
                    </div>
                    <div className="col">
                        <select className="form-select" name="disPoint" value={filters.disPoint} onChange={handleFilterChange}>
                        <option value="">All Dis Points</option>
                        {disPointOptions.map((dis, i) => <option key={i} value={dis}>{dis}</option>)}
                        </select>
                    </div>
                </div>     */}


                <div className="row mb-3">
                    <div className="col">
                        <select
                        className="form-select"
                        name="division"
                        value={filters.division}
                        onChange={handleFilterChange}
                        >
                        <option value="">All Divisions</option>
                        {divisionOptions.map((div, i) => (
                            <option key={i} value={div}>
                            {div}
                            </option>
                        ))}
                        </select>
                    </div>
                    <div className="col">
                        <select
                        className="form-select"
                        name="region"
                        value={filters.region}
                        onChange={handleFilterChange}
                        disabled={!filters.division}
                        >
                        <option value="">All Regions</option>
                        {regionOptions.map((reg, i) => (
                            <option key={i} value={reg}>
                            {reg}
                            </option>
                        ))}
                        </select>
                    </div>
                    <div className="col">
                        <select
                        className="form-select"
                        name="territory"
                        value={filters.territory}
                        onChange={handleFilterChange}
                        disabled={!filters.region}
                        >
                        <option value="">All Territories</option>
                        {territoryOptions.map((ter, i) => (
                            <option key={i} value={ter}>
                            {ter}
                            </option>
                        ))}
                        </select>
                    </div>
                    {/* <div className="col">
                        <select
                        className="form-select"
                        name="disPoint"
                        value={filters.disPoint}
                        onChange={handleFilterChange}
                        disabled={!filters.territory}
                        >
                        <option value="">All Dis Points</option>
                        {disPointOptions.map((dis, i) => (
                            <option key={i} value={dis}>
                            {dis}
                            </option>
                        ))}
                        </select>
                    </div> */}
                    </div>

            </div>  
           
            {
                productStockDataViewIsLoading &&
                <LoadingSpinner />

            }

            {!productStockDataViewIsLoading && <>

              <p className='export-for-excel'>
                <DownloadDropdown excelname='Product Stock Summary Report' />
            </p>
                
                {Array.isArray(filteredData) && filteredData.length <= 0 ? 
                <>
                    <LoadingSpinner />                     
                </>
                :

                    <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        <table id="table-to-xls" className="table table-bordered table-xs">
                            <thead className="thead-light sticky-header  text-center head-font-size">
                                <tr>
                                <th className="sticky-header px-4 py-2 border align-middle" style={{ backgroundColor:'#fff005'}}>Zone</th>
                                <th className="sticky-header px-4 py-2 border align-middle" style={{ backgroundColor:'#ffc000'}}>Division</th>
                                <th className="sticky-header px-4 py-2 border align-middle" style={{ backgroundColor:'#ffc000'}}>DSM Name</th>
                                <th className="sticky-header px-4 py-2 border align-middle" style={{ backgroundColor:'#8db5e3'}}>Region</th>
                                <th className="sticky-header px-4 py-2 border align-middle" style={{ backgroundColor:'#8db5e3'}}>RM Name</th>
                                <th className="sticky-header px-4 py-2 border align-middle" style={{ backgroundColor:'#fedfc5'}}>Territory</th>
                                <th className="sticky-header px-4 py-2 border align-middle"  style={{ backgroundColor:'#fedfc5'}}>TSM Name</th>
                                <th className="sticky-header px-4 py-2 border align-middle" style={{ backgroundColor:'#ffc000'}}>Dis Point</th>
                                <th className="sticky-header border align-middle p-2" style={{ backgroundColor:'#cbbfd9'}}>Opening Value</th>
                                <th className="sticky-header border align-middle p-2" style={{ backgroundColor:'#fce9d9'}}>Lifting Value</th>
                                <th className="sticky-header border align-middle p-2" style={{ backgroundColor:'#92d14f'}}>IMS Value</th>
                                <th className="sticky-header border align-middle p-2" style={{ backgroundColor:'#e36b09'}}>Closing Value</th>
                                <th className="sticky-header border align-middle p-2" style={{ backgroundColor:'#dedac5'}}>Damage Value</th>
                                <th className="sticky-header border align-middle p-2" style={{ backgroundColor:'#ffff00'}}>Net Stock Value</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">                                
                                {Array.isArray(summarizedDataWithEmployees) && summarizedDataWithEmployees.map((row, index) => (                                
                                <tr key={index} className="hover:bg-gray-100">
                                    {/* Zone + NSM */}
                                    <td className="px-4 py-2 border text-left" style={{ backgroundColor: getBgColorByField("zone") }}>{row.zoneName}</td>

                                    {/* Division + DSM */}
                                    <td className="px-4 py-2 border text-left" style={{ backgroundColor: getBgColorByField("division") }}>{row.divisionName}</td>
                                    <td className="px-4 py-2 border text-left" style={{ backgroundColor: getBgColorByField("division") }}>{row.dsmName || "-"}</td>

                                    {/* Region + ASM */}
                                    <td className="px-4 py-2 border text-left" style={{ backgroundColor: getBgColorByField("region") }}>{row.regionName}</td>
                                    <td className="px-4 py-2 border text-left" style={{ backgroundColor: getBgColorByField("region") }}>{row.asmName || "-"}</td>

                                    {/* Territory + TSM */}
                                    <td className="px-4 py-2 border text-left" style={{ backgroundColor: getBgColorByField("territory") }}>{row.territoryName}</td>
                                    <td className="px-4 py-2 border text-left" style={{ backgroundColor: getBgColorByField("territory") }}>{row.tsmName || "-"}</td>

                                    {/* Dis point (no bg) */}
                                    <td className="px-4 py-2 border text-left">{row.disPointName}</td>

                                    {/* Prices */}
                                    <td className="px-4 py-2 border text-right">{Math.round(row.productOpeningPrice)}</td>
                                    <td className="px-4 py-2 border text-right">{Math.round(row.productLiftingPrice)}</td>
                                    <td className="px-4 py-2 border text-right">{Math.round(row.productIMSPrice)}</td>
                                    <td className="px-4 py-2 border text-right">{Math.round(row.productClosingPrice)}</td>
                                    <td className="px-4 py-2 border text-right">{Math.round(row.productDMGPrice)}</td>
                                    <td className="px-4 py-2 border text-right">{Math.round(row.productNetPrice)}</td>
                                </tr>

                                ))}
                            </tbody>
                            </table>
                        
                    </div>
                }
            </>

            }
        </div>
    );
};

export default ProductStockSummaryReport;